import axios from 'axios';
import { redirectToPaymentPort } from '../../utils';
import { API_BASE_URL } from '../../utils/constants';
axios.defaults.withCredentials = true;

// axios.defaults.headers.common.Authorization =
//   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImhhZGkxOUB5YWhvby5jb20iLCJjcmVhdGVkQXQiOiIyMDIzLTEyLTA5VDA3OjQzOjI5LjU5OVoiLCJjb250YWluZXJJZCI6IjVlYmE3MjA4ZGJmNzFkMWIwM2IyOTIyZiIsIm5hbWUiOiLZh9in2K_bjCDYrdis2KrbjCIsInR5cGUiOiIyIiwiaWQiOiI2ODg0MWFhMWRhYjIzODEzOGE3MzNmMWYiLCJpc0NyZWF0b3IiOmZhbHNlLCJpc3MiOiJkYXNoYm9hcmQiLCJpYXQiOjE3NDQxOTk0MzQsImV4cCI6MTc0NDI4NTgzNH0.vBrt8S3QXri4kWgHkGpq7sA4FRn1kuJdr_XibA1YJFc';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,

  headers: {
    'Content-Type': 'application/json',
  },
});

export const handleLoginUser = async (userCredentials) => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/auth/login',
    data: JSON.stringify(userCredentials),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleLogoutUser = async () => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/auth/logout',
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
  return response.data;
};

export const handleResetPassword = async (email) => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/auth/forgetPassword',
    data: JSON.stringify(email),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data.success;
};

export const handleSignup = async ({
  email,
  name,
  otpToken,
  phone,
  signUp,
  site,
  referralCode,
}) => {
  const bodyFormData = new FormData();
  bodyFormData.append('email', email);
  bodyFormData.append('name', name);
  bodyFormData.append('otpToken', otpToken);
  bodyFormData.append('phone', phone);
  bodyFormData.append('signUp', signUp);
  bodyFormData.append('site', site);
  bodyFormData.append('referralCode', referralCode);

  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/Users/signup',
    data: bodyFormData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const isEmailExists = async (email) => {
  const bodyFormData = new FormData();
  bodyFormData.append('email', email);
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/auth/check-account',
    data: bodyFormData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return !response.data.validation.valid;
};

export const isMobileExists = async (mobile) => {
  const bodyFormData = new FormData();
  bodyFormData.append('phone', mobile);
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/auth/check-phone',
    data: bodyFormData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return !response.data.validation.valid;
};

export const handleSendVerificationSms = async (mobile) => {
  const bodyFormData = new FormData();
  bodyFormData.append('phone', mobile);
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/agent/sendVerifySms',
    data: bodyFormData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.success;
};

export const saveAsUnregisteredUser = async ({
  firstName,
  lastName,
  email,
  mobile,
  password,
}) => {
  const bodyFormData = new FormData();
  bodyFormData.append('fname', firstName);
  bodyFormData.append('lname', lastName);
  bodyFormData.append('email', email);
  bodyFormData.append('phone', mobile);
  bodyFormData.append('password', password);
  bodyFormData.append('agentId', 'null');

  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/User/notRegisteredUser',
    withCredentials: true,
    data: bodyFormData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const handleValidateSmsVerificationCode = async ({
  mobile,
  verificationCode,
}) => {
  const bodyFormData = new FormData();
  bodyFormData.append('phone', mobile);
  bodyFormData.append('code', verificationCode);
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/agent/checkVerifySms',
    data: bodyFormData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const handleRedirectToPayment = (invoiceId) => {
  redirectToPaymentPort(invoiceId);
};

export const handleGetCountries = async () => {
  const response = await axiosInstance.get('/countries');

  return response.data;
};

// returns states of a country
export const handleGetStates = async (countryCode) => {
  const response = await axiosInstance.get(
    `/states?countryCode=${countryCode}`
  );

  return response.data;
};

export const handleUserVerifyWithOTV = async (data) => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/auth/verify/code',
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleUserLoginWithOTV = async (userCredentials) => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/auth/login/code',
    data: JSON.stringify(userCredentials),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

// returns cities of a state inside a country
export const handleGetCities = async (countryCode, stateCode) => {
  const response = await axiosInstance.get(
    `/cities?countryCode=${countryCode}&stateCode=${stateCode}`
  );

  return response.data;
};
